import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getGlobalUsers } from "../services/userServices";
import transformToOption from "../utils/transformToOptionSelect";

export function useUserSearch(params) {
  const users = useQuery({
    queryKey: ["userSearch", params],
    queryFn: () => getGlobalUsers(params),
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: !!params && !!params.mail
  });

  return {
    userSearch: users.data ? transformToOption(users.data, "mail") : [],
    isLoadingUserSearch: users.isLoading,
  };
}
